import { ErrorBoundary } from "@prismicio/editor-ui"
import { Suspense } from "react"

import { GlobalBanner } from "./GlobalBanner"
import { useAutoUpgradedBanner } from "./useAutoUpgradedBanner"
import { usePaymentFailedBanner } from "./usePaymentFailedBanner"
import { useUsageBanners } from "./useUsageBanners"

export function GlobalBanners() {
  return (
    <ErrorBoundary>
      <Suspense>
        <InternalGlobalBanners />
      </Suspense>
    </ErrorBoundary>
  )
}

function InternalGlobalBanners() {
  useUsageBanners()
  usePaymentFailedBanner()
  useAutoUpgradedBanner()

  return <GlobalBanner />
}
